import EventItemV4 from './EventItemV4';
import ModuleSectionV4 from './ModuleSectionV4';
import {IEventModuleV4} from '../type';

interface IProps {
  data: IEventModuleV4;
}

export default function EventModuleV4({data}: IProps) {
  const {section, eventList} = data;

  return (
    <ModuleSectionV4
      data-module-type={data.moduleType}
      section={section}
      innerClassName="flex flex-col gap-y-58"
    >
      {eventList.map((item, index) => (
        <EventItemV4 key={index} item={item} />
      ))}
    </ModuleSectionV4>
  );
}
